import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

class InnerHtmlContent extends Component {

  render() {
    const { content, elementClass } = this.props;

    // TODO: When allowing target = _BLANK, we should add "noopener" and "noreferrer" values for rel attribute i.e. node.setAttribute('rel', 'noopener noreferrer');
    // https://medium.com/@darrensimio/security-vulnerability-and-browser-performance-impact-of-target-blank-80e5e67db547
    // https://github.com/cure53/DOMPurify/issues/317
    // We should add hook to "afterSanitizeAttributes" (https://github.com/cure53/DOMPurify/blob/main/demos/hooks-target-blank-demo.html)

    const sanitizedContent = DOMPurify.sanitize(content, { ADD_ATTR: ['target'] });

    if (!sanitizedContent) {
      return null;
    }
    return (
      elementClass ?
        <span
          className={elementClass}
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        /> :
        <span
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        />
    );
  }
}

InnerHtmlContent.propTypes = {
  content: PropTypes.string.isRequired,
  elementClass: PropTypes.string
};

InnerHtmlContent.defaultProps = {
  elementClass: ''
};

export default InnerHtmlContent;



// WEBPACK FOOTER //
// ./src/components/InnerHtmlContent/index.jsx